module.exports = __webpack_public_path__ + "static/media/UserProfileDark.3dc02db1.svg";